<template>
  <div class="container">
    <div class="diff-plan" id="planId1042" v-show="planId==1042">
      <div class="pn-health-tips pn-health-tips-model">
        <img src="../../assets/images/import_pic.png" />
        <div class="title-show">
          <p>投保人确认被保险人是否有以下情况？</p>
        </div>
      </div>
      <div class="pn-health-text pn-health-text-model">
        <p style="margin-bottom: 10px; line-height: 1.5em;">
          <strong>一、保险情况：</strong>
        </p>
        <p
          style="line-height: 1.5em;"
        >被保险人过去2年内投保人身保险或健康保险时，有被保险公司拒保、延期、加费或者附加条件承保。</p>
        <!-- <p style="line-height: 1.5em;">
          （2）被保险人目前专职或兼职从事属于
          <a href="javascript:;" paevent="link" @click="gaoweizhiye">《高危职业表》</a>中所列种类的职业。
        </p> -->
        <p style="margin-top: 20px; margin-bottom: 10px; line-height: 1.5em;">
          <strong>职业情况：</strong>
        </p>
        <p style="margin-left: 24px; text-indent: 0px; line-height: 1.5em;">
          <span style="font-size:15px;font-family:宋体"></span>
        </p>
        <p style="line-height: 1.5em;">被保险人目前专职或兼职从事属于<a href="javascript:;" paevent="link" @click="gaoweizhiye">《高危职业表》</a>中所列种类的职业。中所列种类的职业。</p>
        <!-- <p
          style="line-height: 1.5em;"
        >（2） 被保险人过去1年内是否存在下列症状：反复头痛、晕厥、胸痛、气急、紫绀、持续反复发热、视觉障碍、持续性嘶哑、干咳、抽搐、不明原因出血、皮下出血点、咯血、反复呕吐、进食梗噎感或吞咽困难、呕血、浮肿、腹痛、黄疸、便血、血尿、蛋白尿、性质不明的肿块、结节、囊肿、黑痣增大或淋巴结肿大、原因不明的骨关节疼痛、消瘦（非健身原因所致的体重减轻 5 公斤以上） 。</p>
        <p style="line-height: 1.5em;">（3） 被保险人目前或过往被诊断有以下疾病：</p>
        <p
          style="line-height: 1.5em;"
        >&nbsp;&nbsp;&nbsp;&nbsp;a)1型糖尿病、视网膜病变、失明、视力严重受损、糖尿病酮症酸中毒、肾病、糖尿病足、糖尿病外周神经病变；</p>
        <p style="line-height: 1.5em;">&nbsp;&nbsp;&nbsp;&nbsp;b)良/恶性肿瘤（含原位癌）、白血病、宫颈上皮内瘤变；</p>
        <p style="line-height: 1.5em;">&nbsp;&nbsp;&nbsp;&nbsp;c)甲状腺结节、乳房结节或肿块、胃息肉、肠息肉、肺部结节或磨玻璃影；</p>
        <p
          style="line-height: 1.5em;"
        >&nbsp;&nbsp;&nbsp;&nbsp;d)高血压病、冠心病、心肌病、心肌梗死、脑梗死、脑出血、风湿性心脏病、心功能不全二级以上；</p>
        <p style="line-height: 1.5em;">&nbsp;&nbsp;&nbsp;&nbsp;e)视网膜病变、视神经病变、白内障、青光眼；</p>
        <p style="line-height: 1.5em;">&nbsp;&nbsp;&nbsp;&nbsp;f)肢体的严重外伤；</p>
        <p style="line-height: 1.5em;">&nbsp;&nbsp;&nbsp;&nbsp;g)肝炎（包含肝炎病毒携带者）、肝硬化、胰腺炎；</p>
        <p
          style="line-height: 1.5em;"
        >&nbsp;&nbsp;&nbsp;&nbsp;h)重型再障性贫血、系统性红斑狼疮、类风湿性关节炎、帕金森氏病、癫痫、精神病、慢性阻塞性肺病、多囊卵巢综合征、肢端肥大症；</p>
        <p style="line-height: 1.5em;">&nbsp;&nbsp;&nbsp;&nbsp;i)瘫痪。</p> -->
        <p>
          <br />
        </p>
        <p style="line-height: 1.5em;">
          <strong>健康状况：</strong>
        </p>
        <p
          style="line-height: 1.5em;"
        >被保险人所罹患的慢性病不在可投保疾病清单中，或在可投保疾病清单中但不符合可投保条件。</p>
        <p>
          <br />
        </p>
        <p style="margin-top: 20px; margin-bottom: 10px; line-height: 1.5em;">
        <!-- <strong></strong> -->
         <strong>附：</strong><a href="javascript:;" paevent="link" @click="otherText">《可投保疾病清单》</a>
        </p>

        <!-- <p style="margin-top: 20px; margin-bottom: 10px; line-height: 1.5em;">
          <strong>下述情况，仍可正常投保：</strong>
        </p>
        <p style="line-height: 1.5em;">
          1.&nbsp;&nbsp;
          <strong>甲状腺结节</strong>，但符合以下条件中的任一条：
        </p>
        <p style="line-height: 1.5em;">
          &nbsp;&nbsp;&nbsp;&nbsp;（1）甲状腺结节已行穿刺活检或手术，穿刺活检或手术术后病理为良性者；
          <br />&nbsp;&nbsp;&nbsp;&nbsp;（2）甲状腺结节未穿刺或手术，甲状腺核素检查所有结节均明确为功能性结节者（热结节），或近期1年内超声检查甲状腺分级TI-RADS 3级及以下。
        </p>
        <p style="line-height: 1.5em;">
          2.&nbsp;
          <strong>乳腺结节或增生</strong>，但乳腺检查BI-RADS分级为1级或2级。
        </p>
        <p style="line-height: 1.5em;">
          3.&nbsp;
          <strong>子宫肌瘤</strong>，但大小不超过5cm，且未伴有子宫出血、腹部包块或压迫症状。
        </p>
        <p style="line-height: 1.5em;">
          4.&nbsp;
          <strong>卵巢囊肿</strong>，但符合以下条件中的任一条：
        </p>
        <p style="line-height: 1.5em;">
          &nbsp;&nbsp;&nbsp;&nbsp;（1）确诊为滤泡性囊肿，且单个囊肿直径小于3cm；
          <br />&nbsp;&nbsp;&nbsp;&nbsp;（2）已手术切除，且术后病理结果是否为良性。
        </p>
        <p style="line-height: 1.5em;">
          5.&nbsp;
          <strong>胆囊息肉</strong>，但息肉小于1cm，且近半年复查B超息肉未增大。
        </p>
        <p style="line-height: 1.5em;">
          6.&nbsp;
          <span style="text-decoration: underline; color: rgb(79, 129, 189);">
            <a href="javascript:;" paevent="link" @click="jibingqingdan('tangniaobing')">
              <strong>《可投保疾病清单》</strong>
            </a>
          </span>中的其他疾病。
        </p> -->
        <p>
          <br />
        </p>
      </div>
      <div class="pn-health-confirm pn-health-confirm-model">
        <p>
          <span style="color: rgb(255, 102, 0);">
            <strong>投保人应在对所有被保险人健康/职业状况充分了解的基础上履行如实告知义务。投保人承诺完全知晓所有被保险人健康/职业状况，并如实告知。若被保险人健康/职业状况与告知内容不符：</strong>
          </span>
        </p>
        <p
          style="font-size: 12px;background-color: rgb(246, 247, 249);padding: 10px 5px 10px 15px;margin-top: 10px;border-radius: 8px;"
        >
          （1）一经发现，本公司将依据法律解除合同。
          <br />（2）若发生保险事故，本公司不承担赔偿或给付保险金的责任，并将依据法律解除合同，同时根据投保人不如实告知情况不退还保险费。
        </p>
      </div>
    </div>

    <div class="diff-plan none" id="planId1046" v-show="planId==1046">
      <div class="pn-health-tips pn-health-tips-model">
        <img src="../../assets/images/import_pic.png" />
        <div class="title-show">
          <p>投保人确认被保险人是否有以下情况？</p>
        </div>
      </div>
      <div class="pn-health-text pn-health-text-model">
        <p style="margin-bottom: 10px; line-height: 1.5em;">
          <strong>保险情况：</strong>
        </p>
        <p style="line-height: 1.5em;">被保险人过去2年内投保人身保险或健康保险时，有被保险公司拒保、延期、加费或者附加条件承保。</p>
        <!-- <p style="line-height: 1.5em;">
          （2）被保险人目前专职或兼职从事属于
          <a href="javascript:;" paevent="link" @click="gaoweizhiye">《高危职业表》</a>中所列种类的职业。
        </p> -->
        <p style="margin-top: 20px; margin-bottom: 10px; line-height: 1.5em;">
          <strong>职业情况：</strong>
        </p>
        <p style="line-height: 1.5em;">
          被保险人目前专职或兼职从事属于<a href="javascript:;" paevent="link" @click="gaoweizhiye">《高危职业表》</a>中所列种类的职业；
        </p>
        <!-- <p style="line-height: 1.5em;">
          （2）
          <strong>被保险人过去1年内是否存在下列症状</strong>：
        </p>
        <p
          style="line-height: 1.5em;"
        >&nbsp;&nbsp;&nbsp;&nbsp;反复头痛、晕厥、胸痛、气急、紫绀、持续反复发热、视觉障碍、持续性嘶哑、干咳、抽搐、不明原因出血、皮下出血点、咯血、反复呕吐、进食梗噎感或吞咽困难、呕血、浮肿、腹痛、黄疸、便血、血尿、蛋白尿，性质不明的肿块、结节、囊肿、黑痣增大或淋巴结肿大，原因不明的骨关节疼痛、消瘦（非健身原因所致的体重减轻 5 公斤以上） 。</p>
        <p style="line-height: 1.5em;">
          （3）
          <strong>被保险人目前或过往被诊断患有下列疾病</strong>：
        </p>
        <p style="line-height: 1.5em;">&nbsp; &nbsp; a)&nbsp; 良/恶性肿瘤（含原位癌）、白血病、宫颈上皮内瘤变；</p>
        <p style="line-height: 1.5em;">&nbsp; &nbsp; b)&nbsp; 甲状腺结节，乳房结节或肿块，胃息肉，肠息肉，肺部结节或磨玻璃影；</p>
        <p
          style="line-height: 1.5em;"
        >&nbsp;&nbsp;&nbsp;&nbsp;c)&nbsp; 糖尿病、高血压病3级及以上（未服药情况下，收缩压≥180mmHg，或舒张压≥110mmHg）；</p>
        <p
          style="line-height: 1.5em;"
        >&nbsp;&nbsp;&nbsp;&nbsp;d)&nbsp; 冠心病、心肌病、心肌梗死、主动脉夹层、脑梗死、脑出血、风湿性心脏病、心功能不全二级以上、蛛网膜下腔出血、短暂性脑缺血发作、柯兴综合征、原发性醛固酮增多症、嗜络细胞瘤、高血压脑病或高血压危象；</p>
        <p style="line-height: 1.5em;">&nbsp;&nbsp;&nbsp;&nbsp;e)&nbsp; 慢性肾脏疾病；</p>
        <p style="line-height: 1.5em;">&nbsp;&nbsp;&nbsp;&nbsp;f)&nbsp;&nbsp; 视网膜病变、视神经病变、白内障、青光；</p>
        <p style="line-height: 1.5em;">&nbsp;&nbsp;&nbsp;&nbsp;g)&nbsp; 肢体的严重外伤；</p>
        <p style="line-height: 1.5em;">&nbsp;&nbsp;&nbsp;&nbsp;h)&nbsp; 肝炎（包括肝炎病毒携带者）、肝硬化，</p>
        <p
          style="line-height: 1.5em;"
        >&nbsp;&nbsp;&nbsp;&nbsp;i)&nbsp;&nbsp; 重型再障性贫血、系统性红斑狼疮、类风湿性关节炎、帕金森氏病、癫痫、精神病、慢性阻塞性肺病</p>
        <p style="line-height: 1.5em;">&nbsp;&nbsp;&nbsp;&nbsp;j)&nbsp; &nbsp;瘫痪。</p> -->
        <p style="margin-top: 20px; margin-bottom: 10px; line-height: 1.5em;">
          <strong>健康状况：</strong>
        </p>
        <p
          style="line-height: 1.5em;"
        >被保险人所罹患的慢性病不在可投保疾病清单中，或在可投保疾病清单中但不符合可投保条件。</p>
        <p>
          <br />
        </p>
        <p style="margin-top: 20px; margin-bottom: 10px; line-height: 1.5em;">
        <!-- <strong></strong> -->
        <strong>附：</strong><a href="javascript:;" paevent="link" @click="otherText">《可投保疾病清单》</a>
        </p>
        <!-- <p style="margin-top: 20px; margin-bottom: 10px; white-space: normal; line-height: 1.5em;">
          <strong>以下情况可作为例外事项，仍可符合投保条件：</strong>
        </p>
        <p style="line-height: 1.5em;">
          1.&nbsp;&nbsp;
          <strong>甲状腺结节</strong>，但符合以下条件中的任一条：
        </p>
        <p style="line-height: 1.5em;">
          （1）甲状腺结节已行穿刺活检或手术，穿刺活检或手术术后病理为良性者；
          <br />（2）甲状腺结节未穿刺或手术，甲状腺核素检查所有结节均明确为功能性结节者（热结节），或近期1年内超声检查甲状腺分级TI-RADS 3级及以下。
        </p>
        <p style="line-height: 1.5em;">
          2.&nbsp;
          <strong>乳腺结节或增生</strong>，但乳腺检查BI-RADS分级为1级或2级。
        </p>
        <p style="line-height: 1.5em;">
          3.&nbsp;
          <strong>子宫肌瘤</strong>，但大小不超过5cm，且未伴有子宫出血、腹部包块或压迫症状。
        </p>
        <p style="line-height: 1.5em;">
          4.&nbsp;
          <strong>卵巢囊肿</strong>，但符合以下条件中的任一条：
        </p>
        <p style="line-height: 1.5em;">
          （1）确诊为滤泡性囊肿，且单个囊肿直径小于3cm；
          <br />（2）已手术切除，且术后病理结果是否为良性。
        </p>
        <p style="line-height: 1.5em;">
          5.&nbsp;
          <strong>胆囊息肉</strong>，但息肉小于1cm，且近半年复查B超息肉未增大。
        </p>
        <p style="line-height: 1.5em;">
          6.&nbsp;
          <span style="text-decoration: underline; color: rgb(79, 129, 189);">
            <a href="javascript:;" paevent="link" @click="jibingqingdan('gaoxueya')">
              <strong>《可投保疾病清单》</strong>
            </a>
          </span>中的其他疾病。
        </p> -->
        <p>
          <br />
        </p>
      </div>
      <div class="pn-health-confirm pn-health-confirm-model">
        <p>
          <span style="color: rgb(255, 102, 0);">
            <strong>投保人应在对所有被保险人健康/职业状况充分了解的基础上履行如实告知义务。投保人承诺完全知晓所有被保险人健康/职业状况，并如实告知。若被保险人健康/职业状况与告知内容不符：</strong>
          </span>
        </p>
        <p
          style="font-size: 12px;background-color: rgb(246, 247, 249);padding: 10px 5px 10px 15px;margin-top: 10px;border-radius: 8px;"
        >
          （1）一经发现，本公司将依据法律解除合同。
          <br />（2）若发生保险事故，本公司不承担赔偿或给付保险金的责任，并将依据法律解除合同，同时根据投保人不如实告知情况不退还保险费。
        </p>
      </div>
    </div>

    <div class="diff-plan none" id="planId1050" v-show="planId==1050">
      <div class="pn-health-tips pn-health-tips-model">
        <img src="../../assets/images/import_pic.png" />
        <div class="title-show">
          <p>投保人确认被保险人是否有以下情况？</p>
        </div>
      </div>
      <div class="pn-health-text pn-health-text-model">
        <p style="margin-bottom: 10px; line-height: 1.5em;">
          <strong>保险情况：</strong>
        </p>
        <p style="line-height: 1.5em;">
          被保险人过去2年内投保人身保险或健康保险时，有被保险公司拒保、延期、加费或者附加条件承保；
        </p>
        <p style="margin-top: 20px; margin-bottom: 10px; line-height: 1.5em;">
          <strong>职业情况：</strong>
        </p>
        <p style="line-height: 1.5em;">
          被保险人目前专职或兼职从事属于《高危职业表》中所列种类的职业；
        </p>
        <p style="margin-top: 20px; margin-bottom: 10px; line-height: 1.5em;">
          <strong>健康状况：</strong>
        </p>
        <p
          style="line-height: 1.5em;"
        >被保险人所罹患的慢性病不在可投保疾病清单中，或在可投保疾病清单中但不符合可投保条件。</p>
        <p>
          <br />
        </p>
        <p style="margin-top: 20px; margin-bottom: 10px; line-height: 1.5em;">
        <!-- <strong></strong> -->
        <strong>附：</strong><a href="javascript:;" paevent="link" @click="otherText">《可投保疾病清单》</a>
        </p>
        <!-- <p style="line-height: 1.5em;">&nbsp;&nbsp;&nbsp;&nbsp;a) 恶性肿瘤（含原位癌）、良性肿瘤，宫颈上皮内瘤变；</p>
        <p style="line-height: 1.5em;">&nbsp;&nbsp;&nbsp;&nbsp;b) 乳房结节或肿块，胃息肉、肠息肉、肺部结节或磨玻璃影；</p>
        <p style="line-height: 1.5em;">&nbsp;&nbsp;&nbsp;&nbsp;c) 脑梗死、脑出血、脑血管畸形或脑血管瘤、癫痫、帕金森病；</p>
        <p
          style="line-height: 1.5em;"
        >&nbsp;&nbsp;&nbsp;&nbsp;d) 冠心病、心肌梗死、心绞痛、肺源性心脏病、心脏瓣膜病、心房/心室扑动或颤动、风湿性心脏病、心肌病、先天性心脏病；</p>
        <p style="line-height: 1.5em;">&nbsp;&nbsp;&nbsp;&nbsp;e) 高血压病、糖尿病；</p>
        <p style="line-height: 1.5em;">&nbsp;&nbsp;&nbsp;&nbsp;f) 肝炎（肝炎病毒携带者）、肝硬化；</p>
        <p style="line-height: 1.5em;">&nbsp;&nbsp;&nbsp;&nbsp;g) 慢性阻塞性肺疾病、慢性支气管炎、支气管扩张；</p>
        <p style="line-height: 1.5em;">&nbsp;&nbsp;&nbsp;&nbsp;h) 慢性肾炎、肾病综合征、多囊肾、肾功能不全；</p>
        <p style="line-height: 1.5em;">&nbsp;&nbsp;&nbsp;&nbsp;i) 骨髓增生异常、再生障碍性贫血；</p>
        <p style="line-height: 1.5em;">&nbsp;&nbsp;&nbsp;&nbsp;j) 系统性红斑狼疮、类风湿性关节炎；</p>
        <p style="line-height: 1.5em;">&nbsp;&nbsp;&nbsp;&nbsp;k) 瘫痪；</p>
        <p style="line-height: 1.5em;">&nbsp;&nbsp;&nbsp;&nbsp;l) 艾滋病或艾滋病病毒携带、梅毒、精神疾病。</p>
        <p>
          <br />
        </p>
        <p style="line-height: 1.5em;">
          （2）
          <strong>被保险人过去1年内存在下列症状</strong>：
        </p>
        <p
          style="line-height: 1.5em;"
        >&nbsp;&nbsp;&nbsp;&nbsp;反复头痛、晕厥、胸痛、气急、紫绀、持续反复发热、抽搐、不明原因皮下出血点、咯血、反复呕吐、进食梗噎感或吞咽困难、呕血、浮肿、腹痛（不包括急性肠胃炎、急性胃炎、急性胆囊炎、急性阑尾炎、十二指肠溃疡、异位妊娠、痛经、盆腔炎引起的腹痛）、黄疸（新生儿黄疸已治愈的除外）、便血、血尿、蛋白尿，性质不明的肿块、结节、囊肿、黑痣增大或淋巴结肿大，原因不明的骨关节疼痛、消瘦（非健身原因所致的体重减轻5公斤以上）。</p>
        <p>
          <br />
        </p>
        <p>
          <strong>以下情况可作为例外事项，仍可符合投保条件：</strong>
          <br />
        </p>
        <p style="line-height: 1.5em;">
          <strong>1.&nbsp;&nbsp; 甲状腺结节</strong>，但符合以下条件中的任一条：
        </p>
        <p style="line-height: 1.5em;">
          &nbsp;&nbsp;&nbsp;&nbsp;（1）甲状腺结节已行穿刺活检或手术，穿刺活检或手术术后病理为良性者；
          <br />&nbsp;&nbsp;&nbsp;&nbsp;（2）甲状腺结节未穿刺或手术，甲状腺核素检查所有结节均明确为功能性结节者（热结节），或近期1年内超声检查甲状腺分级TI-RADS 3级及以下。
        </p>
        <p style="line-height: 1.5em;">
          <strong>2.&nbsp; 乳腺结节或增生</strong>，但乳腺检查BI-RADS分级为1级或2级。
        </p>
        <p style="line-height: 1.5em;">
          <strong>3.&nbsp; 子宫肌瘤</strong>，但大小不超过5cm，且未伴有子宫出血、腹部包块或压迫症状。
        </p>
        <p style="line-height: 1.5em;">
          <strong>4.&nbsp; 卵巢囊肿</strong>，但符合以下条件中的任一条：
        </p>
        <p style="line-height: 1.5em;">
          &nbsp;&nbsp;&nbsp;&nbsp;（1）确诊为滤泡性囊肿，且单个囊肿直径小于3cm；
          <br />&nbsp;&nbsp;&nbsp;&nbsp;（2）已手术切除，且术后病理结果是否为良性。
        </p>
        <p style="line-height: 1.5em;">
          <strong>5.&nbsp; 胆囊息肉</strong>，但息肉小于1cm，且近半年复查B超息肉未增大。
        </p>
        <p style="line-height: 1.5em;">
          6.&nbsp;
          <span style="text-decoration: underline;">
            <a href="javascript:;" paevent="link" @click="jibingqingdan('jiazhuangxian')">
              <strong>《可投保疾病清单》</strong>
            </a>
          </span>中的其他疾病。
        </p> -->
      </div>
      <div class="pn-health-confirm pn-health-confirm-model">
        <p>
          <span style="color: rgb(255, 102, 0);">
            <strong>投保人应在对所有被保险人健康/职业状况充分了解的基础上履行如实告知义务。投保人承诺完全知晓所有被保险人健康/职业状况，并如实告知。若被保险人健康/职业状况与告知内容不符：</strong>
          </span>
        </p>
        <p
          style="font-size: 12px;background-color: rgb(246, 247, 249);padding: 10px 5px 10px 15px;margin-top: 10px;border-radius: 8px;"
        >
          （1）一经发现，本公司将依据法律解除合同。
          <br />（2）若发生保险事故，本公司不承担赔偿或给付保险金的责任，并将依据法律解除合同，同时根据投保人不如实告知情况不退还保险费。
        </p>
      </div>
    </div>

    <div class="diff-plan none" id="planId1054" v-show="planId==1054">
      <div class="pn-health-tips pn-health-tips-model">
        <img src="../../assets/images/import_pic.png" />
        <div class="title-show">
          <p>投保人确认被保险人是否有以下情况？</p>
        </div>
      </div>
      <div class="pn-health-text pn-health-text-model">
        <ul class="list-paddingleft-2" style="list-style-type: disc;">
          <li>
            <p style="margin-bottom: 10px; line-height: 1.5em;">
              <strong>保险情况：</strong>
            </p>
          </li>
          <li>
            <p style="line-height: 1.5em;">被保险人过去2年内投保人身保险或健康保险时，有被保险公司拒保、延期、加费或者附加条件承保；</p>
          </li>
          <!-- <li>
            <p style="line-height: 1.5em;">
              （2）被保险人目前专职或兼职从事属于
              <a href="javascript:;" paevent="link" @click="gaoweizhiye">《高危职业表》</a>中所列种类的职业。
            </p>
          </li> -->
          <li>
            <p style="margin-top: 20px; margin-bottom: 10px; line-height: 1.5em;">
              <strong>职业情况：</strong>
            </p>
          </li>
          <li>
            <p style="line-height: 1.5em;">
              被保险人目前专职或兼职从事属于<a href="javascript:;" paevent="link" @click="gaoweizhiye">《高危职业表》</a>中所列种类的职业；
              <!-- <strong>被保险人目前或过往是否被诊断患有下列疾病：</strong> -->
            </p>
          </li>
          <!-- <li>
            <p style="line-height: 1.5em;">&nbsp;&nbsp;&nbsp;&nbsp;a)恶性肿瘤（含原位癌）、良性肿瘤，宫颈上皮内瘤变；</p>
          </li>
          <li>
            <p
              style="line-height: 1.5em;"
            >&nbsp;&nbsp;&nbsp;&nbsp;b)甲状腺结节、乳房结节或肿块，胃息肉、肠息肉、肺部结节或磨玻璃影；</p>
          </li>
          <li>
            <p style="line-height: 1.5em;">&nbsp;&nbsp;&nbsp;&nbsp;c)脑梗死、脑出血、脑血管畸形或脑血管瘤、癫痫、帕金森病；</p>
          </li>
          <li>
            <p
              style="line-height: 1.5em;"
            >&nbsp;&nbsp;&nbsp;&nbsp;d)冠心病、心肌梗死、心绞痛、肺源性心脏病、心脏瓣膜病、心房/心室扑动或颤动、风湿性心脏病、心肌病、先天性心脏病；</p>
          </li>
          <li>
            <p style="line-height: 1.5em;">&nbsp;&nbsp;&nbsp;&nbsp;e)高血压病、糖尿病；</p>
          </li>
          <li>
            <p style="line-height: 1.5em;">&nbsp;&nbsp;&nbsp;&nbsp;f)肝炎（肝炎病毒携带者）、肝硬化；</p>
          </li>
          <li>
            <p style="line-height: 1.5em;">&nbsp;&nbsp;&nbsp;&nbsp;g)慢性阻塞性肺疾病、慢性支气管炎、支气管扩张；</p>
          </li>
          <li>
            <p style="line-height: 1.5em;">&nbsp;&nbsp;&nbsp;&nbsp;h)慢性肾炎、肾病综合征、多囊肾、肾功能不全；</p>
          </li>
          <li>
            <p style="line-height: 1.5em;">&nbsp;&nbsp;&nbsp;&nbsp;i)骨髓增生异常、再生障碍性贫血；</p>
          </li>
          <li>
            <p style="line-height: 1.5em;">&nbsp;&nbsp;&nbsp;&nbsp;j)系统性红斑狼疮、类风湿性关节炎；</p>
          </li>
          <li>
            <p style="line-height: 1.5em;">&nbsp;&nbsp;&nbsp;&nbsp;k)瘫痪；</p>
          </li>
          <li>
            <p style="line-height: 1.5em;">&nbsp;&nbsp;&nbsp;&nbsp;l)艾滋病或艾滋病病毒携带、梅毒、精神疾病。</p>
          </li>
          <li>
            <p style="line-height: 1.5em;">
              （2）
              <strong>被保险人过去1年内存在下列症状：</strong>
            </p>
          </li>
          <li>
            <p
              style="line-height: 1.5em;"
            >反复头痛、晕厥、胸痛、气急、紫绀、持续反复发热、抽搐、不明原因皮下出血点、咯血、反复呕吐、进食梗噎感或吞咽困难、呕血、浮肿、腹痛（不包括急性肠胃炎、急性胃炎、急性胆囊炎、急性阑尾炎、十二指肠溃疡、异位妊娠、痛经、盆腔炎引起的腹痛）、黄疸（新生儿黄疸已治愈的除外）、便血、血尿、蛋白尿，性质不明的肿块、结节、囊肿、黑痣增大或淋巴结肿大，原因不明的骨关节疼痛、消瘦（非健身原因所致的体重减轻5公斤以上）。</p>
          </li>
          <li>
            <p style="line-height: 1.5em;">
              （3）
              <strong>医疗行为：</strong>
            </p>
          </li>
          <li>
            <p
              style="line-height: 1.5em;"
            >被保险人过去2年内是否住院或被要求进一步检查、手术或治疗（不包括剖腹产/顺产/鼻炎/急性胃肠炎/单次发作已痊愈的肺炎/上呼吸道感染住院）。</p>
          </li> -->
          <li>
            <p style="margin-top: 20px; margin-bottom: 10px; line-height: 1.5em;">
              <!-- <strong></strong> -->
              <strong>健康状况：</strong>
            </p>
          </li>
          <li>
            <p style="line-height: 1.5em;">
             被保险人所罹患的慢性病不在可投保疾病清单中，或在可投保疾病清单中但不符合可投保条件。
              <!-- <strong>甲状腺结节</strong>，但符合以下条件中的任一条： -->
            </p>
          </li>
          <!-- <li>
            <p style="line-height: 1.5em;">
              （1）甲状腺结节已行穿刺活检或手术，穿刺活检或手术术后病理为良性者；
              <br />（2）甲状腺结节未穿刺或手术，甲状腺核素检查所有结节均明确为功能性结节者（热结节），或近期1年内超声检查甲状腺分级TI-RADS 3级及以下。
            </p>
          </li>
          <li>
            <p style="line-height: 1.5em;">
              2.&nbsp;
              <strong>乳腺结节或增生</strong>，但乳腺检查BI-RADS分级为1级或2级。
            </p>
          </li>
          <li>
            <p style="line-height: 1.5em;">
              3.&nbsp;
              <strong>子宫肌瘤</strong>，但大小不超过5cm，且未伴有子宫出血、腹部包块或压迫症状。
            </p>
          </li>
          <li>
            <p style="line-height: 1.5em;">
              4.&nbsp;
              <strong>卵巢囊肿</strong>，但符合以下条件中的任一条：
            </p>
          </li>
          <li>
            <p style="line-height: 1.5em;">
              （1）确诊为滤泡性囊肿，且单个囊肿直径小于3cm；
              <br />（2）已手术切除，且术后病理结果是否为良性。
            </p>
          </li>
          <li>
            <p style="line-height: 1.5em;">
              5.&nbsp;
              <strong>胆囊息肉</strong>，但息肉小于1cm，且近半年复查B超息肉未增大。
            </p>
          </li>
          <li>
            <p style="line-height: 1.5em;">
              6.&nbsp;
              <span style="text-decoration: underline; color: rgb(79, 129, 189);">
                <a href="javascript:;" paevent="link" @click="jibingqingdan('qitajibing')">
                  <strong>《可投保疾病清单》</strong>
                </a>
              </span>中的其他疾病。
            </p>
          </li> -->
          <li>
              <p style="margin-top: 20px; margin-bottom: 10px; line-height: 1.5em;">
              <!-- <strong></strong> -->
              <strong>附：</strong><a href="javascript:;" paevent="link" @click="otherText">《可投保疾病清单》</a>
            </p>
          </li>
          <li>
            <p>
              <br />
            </p>
          </li>
        </ul>
      </div>
      <div class="pn-health-confirm pn-health-confirm-model">
        <p>
          <span style="color: rgb(255, 102, 0);">
            <strong>投保人应在对所有被保险人健康/职业状况充分了解的基础上履行如实告知义务。投保人承诺完全知晓所有被保险人健康/职业状况，并如实告知。若被保险人健康/职业状况与告知内容不符：</strong>
          </span>
        </p>
        <p
          style="font-size: 12px;background-color: rgb(246, 247, 249);padding: 10px 5px 10px 15px;margin-top: 10px;border-radius: 8px;"
        >
          （1）一经发现，本公司将依据法律解除合同。
          <br />（2）若发生保险事故，本公司不承担赔偿或给付保险金的责任，并将依据法律解除合同，同时根据投保人不如实告知情况不退还保险费。
        </p>
      </div>
    </div>

    <div class="dailog-rule-word" v-show="showflag">
      <div class="inner">
        <h3>{{title_word}}</h3>
        <div class="inner-2">
          <p>{{content_word}}</p>
        </div>
        <div class="bottom-btn">
          <a href="javascript:void(0);" class="desc-ok" @click=" showflag=false ">我知道了</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["planId"],
  data() {
    return {
      title_word: "",
      content_word: "",
      showflag: false
      // planid: planid
    };
  },
  ready() {
    let self = this;
    self.id = this.$route.query.planid;
  },
  route: {
    data: function() {
      document.title = "健康告知 - 平安健康";
    }
  },
  methods: {
    wordDesc: function(e) {
      let self = this;
      var cur = e.target.dataset;
      self.title_word = cur.title;
      self.content_word = cur.content;
      self.showflag = true;
    },

    async gaoweizhiye() {
      this.$router.push({
        name: "ThirdPage",
        query: {
          url: "https://m.health.pingan.com/share/page/38/101.html",
          title: "高危职业表"
        }
      });
    },
    async otherText(){
        this.$router.push({
        name: "ThirdPage",
        query: {
          url: "https://m.health.pingan.com/share/page/54/101.pdf",
          title: "可投保疾病清单"
        }
      });
    },
    async jibingqingdan(type) {
      let url = "";
      if (type == "tangniaobing") {
        url = "https://m.health.pingan.com/share/page/52/101.html";
      } else if (type == "gaoxueya") {
        url = "https://m.health.pingan.com/share/page/52/0.html";
      } else if (type == "jiazhuangxian") {
        url = "https://m.health.pingan.com/share/page/52/51.html";
      } else {
        url = "https://m.health.pingan.com/share/page/52/52.html";
      }
      this.$router.push({
        name: "ThirdPage",
        query: {
          url: url,
          title: "可投保疾病清单"
        }
      });
    }
  }
};
</script>

<style scoped lang="stylus">
.diff-plan {
  margin-bottom: 65px;
  background: #fff;
}

.pn-health-tips-model {
  font-weight: 500;
  border: 0;
  background: #FAEBE1;
  padding: 14px 9px 12px 16px;
  line-height: 20px;
  text-align: left;
  font-size: 14px;
  position: relative;
  color: #f60;

  img {
    width: 46px;
    margin-right: 5px;
    float: left;
    margin-top: 2px;
  }

  .title-show {
    text-align: left;
    font-weight: 500;
  }
}

.pn-health-confirm-model {
  background: #fff;
  border-top: 10px solid #F9F9FB;
  font-size: 14px;
  padding: 15px;
  color: #333;
}

.pn-health-text-model {
  color: #333;
  border: none;
  padding: 15px;

  p {
    margin-bottom: 0px;
  }
}

.dailog-rule-word {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.3);
  z-index: 100;

  .inner {
    position: absolute;
    top: 50%;
    left: 50%;
    width: 92%;
    border-radius: 4px;
    -webkit-transform: translate(-50%, -50%);
    -moz-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
    background: #fff;
    padding: 15px;
    color: #666;

    h3 {
      color: #333;
      font-weight: 500;
      font-size: 16px;
      width: 160px;
      height: 35px;
      margin: 0 auto;
      text-align: center;
      line-height: 35px;
    }

    p {
      padding-bottom: 10px;
    }
  }

  .inner-2 {
    margin: 5px;
    overflow: auto;
    max-height: 332px;
    font-size: 14px;
    height: auto;
    overflow-y: scroll;
    -webkit-overflow-scrolling: touch;
  }

  .desc-ok {
    width: 144px;
    height: 35px;
    border-radius: 35px;
    text-align: center;
    line-height: 35px;
    color: #f60;
    margin: 0 auto;
    display: block;
    border: 1px solid #f60;
    font-size: 15px;
    cursor: pointer;
  }
}
</style>



















